<div class="d-lg-none">
  <fgb-page-header [pageTitle]="'transactions.page.title'" [showFooter]="true" [backButtonLink]="'/'" />
</div>

<div class="container">
  <fgb-transaction-history
    [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
    [ecashView]="true"
  ></fgb-transaction-history>
</div>
